var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlider8(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 75,
    viewBox: "0 0 97 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22_388)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M82.0066 6.28116C75.7397 3.34684 69.0391 1.2142 62.0341 0C61.1734 1.55666 60.1684 3.65038 59.4756 5.316C52.0287 4.19522 44.6503 4.19522 37.3406 5.316C36.6478 3.65038 35.6197 1.55666 34.7519 0C27.739 1.2142 21.0307 3.35463 14.7642 6.29672C2.12433 25.4125 -1.30213 44.0537 0.411102 62.43C8.7945 68.6956 16.919 72.5016 24.9064 74.9922C26.8786 72.2759 28.6375 69.3884 30.1528 66.345C27.2669 65.2475 24.5029 63.8934 21.8912 62.3209C22.5841 61.8075 23.2617 61.2703 23.9166 60.7178C39.8459 68.1741 57.1531 68.1741 72.8922 60.7178C73.5544 61.2703 74.2322 61.8075 74.9175 62.3209C72.2981 63.9009 69.5266 65.2553 66.6406 66.3528C68.1559 69.3884 69.9072 72.2838 71.8869 75C79.8819 72.5094 88.0141 68.7034 96.3975 62.43C98.4078 41.1272 92.9634 22.6572 82.0066 6.28116ZM32.3228 51.1288C27.541 51.1288 23.6196 46.6609 23.6196 41.2206C23.6196 35.78 27.4572 31.3047 32.3228 31.3047C37.1884 31.3047 41.1097 35.7722 41.0259 41.2206C41.0337 46.6609 37.1884 51.1288 32.3228 51.1288ZM64.4859 51.1288C59.7041 51.1288 55.7825 46.6609 55.7825 41.2206C55.7825 35.78 59.6203 31.3047 64.4859 31.3047C69.3512 31.3047 73.2728 35.7722 73.1891 41.2206C73.1891 46.6609 69.3512 51.1288 64.4859 51.1288Z",
    fill: "#5865F2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22_388"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96.875,
    height: 75,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlider8);
export default __webpack_public_path__ + "static/media/slider-8.070591e761df494c127a31d0198d41be.svg";
export { ForwardRef as ReactComponent };